import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Client, ProductGroup } from '@app/core/models/client';
import { CharacterLimits } from '@app/core/utils/characterLimits';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { ClientHeaderComponent } from '../../../../shared/client-header/client-header.component';
import { RadioBtnComponent } from '../../../../shared/radio-btn/radio-btn.component';
import { NgClass } from '@angular/common';
import { NewGenericPhoneComponent } from '../../../../shared/new-generic-phone/new-generic-phone.component';
import { SetPasswordPagePreviewReactContainerComponent } from '../set-password-page-preview-react-container/set-password-page-preview-react-container.component';
import { PasswordPreviewComponent } from '../../../../shared/phone/password-preview/password-preview.component';
import { FormInputStateControlComponent } from '../../../../shared/form-input-state-control/form-input-state-control.component';
import { TinyEditorComponent } from '../../../../shared/tiny-editor/tiny-editor.component';

@Component({
    selector: 'app-product-group-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss'],
    standalone: true,
    imports: [
        ClientHeaderComponent,
        RadioBtnComponent,
        NgClass,
        NewGenericPhoneComponent,
        SetPasswordPagePreviewReactContainerComponent,
        PasswordPreviewComponent,
        FormsModule,
        ReactiveFormsModule,
        FormInputStateControlComponent,
        TinyEditorComponent,
    ],
})
export class ProductGroupFeaturesComponent implements OnInit {
  @Input() productGroup: ProductGroup;
  @Input() client: Client;

  @ViewChild(MessageDialogComponent) messageDialog: MessageDialogComponent;

  headerGroups = { features: true, password: true };
  passwordForm: UntypedFormGroup;

  setPasswordSubmitButtonDefaultText: string = 'Submit';

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.passwordForm = this.client.feed_enabled
      ? this.formBuilder.group({
          text: new UntypedFormControl(this.productGroup.password.text, [
            Validators.required,
            Validators.maxLength(CharacterLimits.PasswordRequiredMessageText),
          ]),
          label: new UntypedFormControl(this.productGroup.password.label, [
            Validators.required,
            Validators.maxLength(
              CharacterLimits.PasswordRequiredSubmitButtonLabel,
            ),
          ]),
        })
      : this.formBuilder.group({
          text: [this.productGroup.password.text],
          label: [this.productGroup.password.label, Validators.required],
        });

    // not all the field values are on the form
    this.passwordForm.valueChanges.subscribe(() => {
      this.productGroup.password.text =
        this.passwordForm.controls['text'].value;
      this.productGroup.password.label =
        this.passwordForm.controls['label'].value;
    });
  }

  passwordHasTextError(): boolean {
    return (
      this.productGroup.password.enabled &&
      (this.productGroup.password.text?.length ?? 0) === 0 &&
      this.passwordForm.controls['text'].dirty
    );
  }

  showTC(): boolean {
    return (
      (this.productGroup.consent.in_wire_upgrade.enabled_on_set_password &&
        this.productGroup.password.enabled) ||
      this.productGroup.consent.in_wire_upgrade.enabled
    );
  }

  getCharacterLimit(form: string) {
    switch (form) {
      case 'setPasswordText':
        return CharacterLimits.PasswordRequiredMessageText;
      case 'setPasswordSubmitButtonLabel':
        return CharacterLimits.PasswordRequiredSubmitButtonLabel;
    }
  }
}
